import { DamageConfig } from './aptConfig'
import { Area } from './infrastructure'
import { AreaInspection, TenantMoveInInspection } from './inspection'
import { Attachment } from './message'
import { IdentifiableObject } from './types'
import { User } from './user'
import { FinalMoveOutStatus } from '../containers/MoveOut/types'

export interface ApartmentAddress extends IdentifiableObject {
    address1: string
    address2: string
    city: string
    state: string
    zip_code: string
    country: string
    longitude: number
    latitude: number
    utc_offset: number
    dst_offset: number
    verified: boolean
    timezone_name: string
    timezone_id: string
    company: number | null
}

export interface Lease extends IdentifiableObject {
    apartment_move_in_inspection?: AreaInspection
    apartment_move_out_inspection?: AreaInspection | null
    area: Area
    children?: Lease[]
    end_date: string
    start_date: string
    entrata_lease_id?: number
    rent: number
    status: LeaseStatusType
    user: User
    tenant_move_in_inspection?: TenantMoveInInspection
    allow_service_request?: boolean
    latest_damage_report?: {
        id: number
        name: string
        creation_time: string
        file: string
        tenant_viewed: boolean
    } | null
    apartment_name?: string
    apartment_id?: number
    apartment_allow_service_request?: boolean
    apartment_primary_address?: ApartmentAddress | null
    allow_rent: boolean
    final_move_out_status?: FinalMoveOutStatus | null
}

export const LeaseStatus = {
    APPLICANT: 1,
    CANCELLED: 2,
    FUTURE: 3,
    CURRENT: 4,
    NOTICE: 5,
    PAST: 6,
} as const

export type LeaseStatusType = (typeof LeaseStatus)[keyof typeof LeaseStatus]

export enum DamageStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    ENTRATA_SYNCED = 'ENTRATA_SYNCED',
    SYNC_PENDING = 'SYNC_PENDING',
    PRE_APPROVED = 'PRE_APPROVED',
    SYNC_FAILED = 'SYNC_FAILED',
}

export interface Damage extends IdentifiableObject {
    damage_config?: DamageConfig
    lease: Lease[]
    amount: number
    unit: number
    area: number
    inspection: number
    channel: number
    message_count: number
    description?: string
    cost: number
    unit_name: string
    folder_name: string
    folder_path: string
    area_config_name: string
    area_label: string
    damage_transactions: DamageTransaction[]
    transactions_created: boolean
    attachments: Attachment[]
    status: DamageStatus
    created_date: string
    inspection_name: string
    attachment_to_sync: number | null
}

export interface DamageTransaction {
    id: number
    lease: Lease
    synced_id: string | null
}